export default __webpack_public_path__ + "static/media/app_cpcpay.7d589de4.png";